import React, { useEffect, useState } from 'react'
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBIcon,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBBtn,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBCollapse,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBCard,
    MDBCardBody,
    MDBCardText,
    MDBModal,
} from 'mdb-react-ui-kit';
import { Class, EasyMembrLogo, Leadmanagement, Member, Membermanage } from '../assets/images/images';
import { useNavigate } from 'react-router';

const NavigationBar = ({ classText, from }) => {
    const [scrolled, setScrolled] = useState(false)
    const [openBasic, setOpenBasic] = useState(false)
    const navigate = useNavigate();
    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const vh20 = window.innerHeight * 0.3;
            setScrolled(scrollY > vh20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    console.log(from, 'from');

    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen = () => setBasicModal(!basicModal);

    const handleLogin = (path) => {
        navigate(path);
    }
    return (
        <>
            <div className={`lp ${!scrolled ? classText : ''}`}>
                <MDBNavbar expand='lg' className={`navbar ${scrolled ? 'opaque' : ''}`}>
                    <MDBContainer fluid>
                        <MDBNavbarBrand href='#'>
                            <img src={EasyMembrLogo} alt="" className='logo' width={200} />
                        </MDBNavbarBrand>
                        <MDBNavbarToggler
                            aria-controls='navbarSupportedContent'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                            onClick={() => setOpenBasic(!openBasic)}
                        >
                            <MDBIcon icon='bars' fas />
                        </MDBNavbarToggler>

                        <MDBCollapse navbar open={openBasic}>
                            <MDBNavbarNav className='mr-auto mb-2 mb-lg-0 align-items-center'>
                                <MDBNavbarItem>
                                    <MDBNavbarLink active={from === 'home'} aria-current='page' href='/'>
                                        Home
                                    </MDBNavbarLink>
                                </MDBNavbarItem>
                                <MDBNavbarItem>
                                    <MDBNavbarLink active={from === 'products'} href='/products'>Products</MDBNavbarLink>
                                </MDBNavbarItem>
                                <MDBNavbarItem>
                                    <MDBDropdown >
                                        <MDBDropdownToggle
                                            // active={['yoga', 'dance', 'mma', 'pilates', 'swimming', 'industry'].includes(from)}
                                            tag='a'
                                            className={`nav-link ${['yoga', 'dance', 'mma', 'pilates', 'swimming', 'industry'].includes(from) ? 'active' : ''}`}
                                            role='button'
                                        >
                                            Industry
                                        </MDBDropdownToggle>
                                        <MDBDropdownMenu>
                                            <MDBDropdownItem link href='/yogastudio'>Yoga Studio Software</MDBDropdownItem>
                                            <MDBDropdownItem link href='/dancestudio'>Dance Studio Software</MDBDropdownItem>
                                            <MDBDropdownItem link href='/gymstudio'>Gym Studio Software</MDBDropdownItem>
                                            {/* <MDBDropdownItem link href='/martialstudio'>Martial Arts Studio Software</MDBDropdownItem>
                                            <MDBDropdownItem link href='/pilatesstudio'>Pilates Studio Software</MDBDropdownItem>
                                            <MDBDropdownItem link href='/swimmingstudio'>Swimming Pool Management Software</MDBDropdownItem> */}
                                        </MDBDropdownMenu>
                                    </MDBDropdown>
                                </MDBNavbarItem>
                                {/* <MDBNavbarItem>
                                    <MDBNavbarLink href='#' tabIndex={-1}>
                                        Blogs
                                    </MDBNavbarLink>
                                </MDBNavbarItem> */}
                                <MDBNavbarItem>
                                    <MDBNavbarLink active={from == 'pricing'} href='/commercials'>
                                        Pricing
                                    </MDBNavbarLink>
                                </MDBNavbarItem>
                                <MDBNavbarItem>
                                    <MDBNavbarLink active={from == 'contact'} href='/contactus'>
                                        Contact
                                    </MDBNavbarLink>
                                </MDBNavbarItem>

                                <MDBNavbarItem>
                                    <MDBBtn onClick={() =>
                                        handleLogin("/login")
                                        // setBasicModal(true)
                                    }
                                        // color='primary'
                                        className="btn btn-cta trial-button"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#startTrialModal"
                                    >
                                        Login
                                    </MDBBtn>
                                </MDBNavbarItem>

                                {/* <MDBNavbarItem className='bg-light rounded-3 shadow-2-strong'>
                                    <MDBNavbarLink href='#' className='text-primary'>
                                        <MDBIcon fas icon="phone-alt" className='me-2' />
                                        +91 8019296262
                                    </MDBNavbarLink>
                                </MDBNavbarItem> */}

                            </MDBNavbarNav>
                        </MDBCollapse>
                    </MDBContainer>
                </MDBNavbar>
            </div>

            {/* {basicModal && <>
                <Popup />
            </>} */}
            <MDBModal show={basicModal} setShow={setBasicModal} open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Login to</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>

                            <div className='d-block d-md-flex'>
                                <MDBCard className='custom-shaow me-0 me-md-4 mb-3 mb-md-0' onClick={() => handleLogin("/login")}>
                                    <MDBCardBody>
                                        <div className='login-tab text-center'>
                                            <img src={Member} />
                                            <h5>Member Management</h5>
                                        </div>
                                    </MDBCardBody>
                                </MDBCard>
                                <MDBCard className='custom-shaow' onClick={() => handleLogin("/classlogin")}>
                                    <MDBCardBody>
                                        <div className='login-tab text-center'>
                                            <img src={Class} />
                                            <h5>Class Management</h5>
                                        </div>
                                    </MDBCardBody>
                                </MDBCard>

                            </div>

                        </MDBModalBody>

                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

        </>
    )
}

export default NavigationBar
